import { IClass } from "../models/foundationProgram";

export const ClassListConstants = [
    {
        classId: 1,
        className: '1st Class'
    },
    {
        classId: 2,
        className: '2nd Class'
    },
    {
        classId: 3,
        className: '3rd Class'
    },
    {
        classId: 4,
        className: '4th Class'
    },
    {
        classId: 5,
        className: '5th Class'
    },
    {
        classId: 6,
        className: '6th Class'
    },
    {
        classId: 7,
        className: '7th Class'
    },
    {
        classId: 8,
        className: '8th Class'
    },
    {
        classId: 9,
        className: '9th Class'
    },
    {
        classId: 10,
        className: '10th Class'
    }
] as IClass[];